import {useMemo} from 'react';

import {ChartRenderer} from '../chart-renderer/chart-renderer';

import {radarChartDashLine, radarChartOptions} from './radar-chart-helper';
import {
    ChartJsRadarDataSetType,
    ChartJsRadarDataType,
    ChartJsRadarOptionsType,
    RadarDataSetType,
    RadarDataType,
    RadarLabelType,
} from './radar-chart-type';

type PropsType = {
    data: RadarDataType;
    options?: ChartJsRadarOptionsType;
};

export function RadarChart(props: PropsType): JSX.Element {
    const {data, options} = props;

    const chartJsData: ChartJsRadarDataType = useMemo<ChartJsRadarDataType>(
        (): ChartJsRadarDataType => ({
            labels: data.labels,
            datasets: data.datasets.map(
                ({label, values, color, dataLabelFormatter, dashed}: RadarDataSetType): ChartJsRadarDataSetType => ({
                    label,
                    data: values,
                    borderColor: color.lineColor,
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointBackgroundColor: color.lineColor,
                    backgroundColor: color.areaColor,
                    ...(dashed ? {borderDash: radarChartDashLine} : {}),
                    borderWidth: 1,
                    datalabels: {
                        formatter: dataLabelFormatter,
                    },
                })
            ),
        }),
        [data]
    );

    return (
        <ChartRenderer<'radar', Array<number>, RadarLabelType>
            data={chartJsData}
            options={options || radarChartOptions}
            type="radar"
        />
    );
}
